/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum PortalFlow {
	UPDATE_PAYMENT = 'update_payment',
	UPDATE_PLAN = 'update_plan'
}
